import { render, staticRenderFns } from "./BaseProductColorSwatches.vue?vue&type=template&id=1a506d8c&"
import script from "./BaseProductColorSwatches.vue?vue&type=script&lang=js&"
export * from "./BaseProductColorSwatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a506d8c')) {
      api.createRecord('1a506d8c', component.options)
    } else {
      api.reload('1a506d8c', component.options)
    }
    module.hot.accept("./BaseProductColorSwatches.vue?vue&type=template&id=1a506d8c&", function () {
      api.rerender('1a506d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductColorSwatches.vue"
export default component.exports